module.exports = __webpack_public_path__ + "media/images/sp/accessories/dress/dress_03_thumb-1afd07a7eea3259e397360d0e0f09fd1.jpg";